/**
 * @generated SignedSource<<81488bb1dc62e078b5c49103a822e465>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type PdpSharedSidebarBuyerIncentives_user$data = {
  readonly isVerifiedTrade: boolean | null;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedDibsPromiseModalLazy_user">;
  readonly " $fragmentType": "PdpSharedSidebarBuyerIncentives_user";
};
export type PdpSharedSidebarBuyerIncentives_user$key = {
  readonly " $data"?: PdpSharedSidebarBuyerIncentives_user$data;
  readonly " $fragmentSpreads": FragmentRefs<"PdpSharedSidebarBuyerIncentives_user">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "PdpSharedSidebarBuyerIncentives_user",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "isVerifiedTrade",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "PdpSharedDibsPromiseModalLazy_user"
    }
  ],
  "type": "User",
  "abstractKey": null
};

(node as any).hash = "04e83cee257b86a0ee44c1752504b2b8";

export default node;
